/* Package JSON Import will be here */
import React, { Component } from 'react';
/* Package JSON Import will be here */

/* Project Import will be here */
import ImageUploadContainer from './image-upload.container';
/* Project Import will be here */

export default class ImageUploadScreen extends Component {

    render() {
        const WrappedImageUploadScreen = ImageUploadContainer;

        return (
            <WrappedImageUploadScreen />
        );
    }
}

ImageUploadScreen.displayName = 'ImageUploadScreen';